<!--
  «Completar mi parte» — la carga paso a paso de la solicitud de alta (CONTRATO-REDISENO-ALTAS.md,
  pantalla B). El ejecutivo carga datos, contactos, documentos y la visita; el gerente, las
  condiciones (con `app-condiciones-pasos`, el mismo de la «Nueva versión» del comercio).
-->
<div class="kb-page kb-gateway">

  <nav class="kb-migas" aria-label="Ubicación">
    <a class="kb-miga" [routerLink]="['/console/altas']">Altas de comercios</a>
    <span class="kb-miga-sep" aria-hidden="true"><i class="fas fa-chevron-right"></i></span>
    <a class="kb-miga" [routerLink]="['/console/altas', id]">{{ sol?.numero || 'Solicitud' }}</a>
    <span class="kb-miga-sep" aria-hidden="true"><i class="fas fa-chevron-right"></i></span>
    <span class="kb-miga-actual">{{ cargaCondiciones ? 'Cargar las condiciones' : 'Cargar el expediente' }}</span>
  </nav>

  <div class="space-y-6" *ngIf="cargando" aria-hidden="true">
    <div class="kb-skeleton h-9 w-1/3"></div>
    <div class="kb-skeleton h-56 w-full"></div>
  </div>
  <p class="sr-only" *ngIf="cargando">Cargando.</p>

  <div class="kb-aviso kb-aviso-info" *ngIf="!cargando && !sol && noExiste">
    <i class="fas fa-info-circle mt-0.5" aria-hidden="true"></i>
    <div>
      <p class="kb-aviso-titulo">Esa solicitud no existe</p>
      <p>Puede que se haya movido o que el número esté mal escrito.</p>
      <a class="kb-btn kb-btn-outline kb-btn-sm mt-3 !text-foreground" [routerLink]="['/console/altas']">Ir a la bandeja</a>
    </div>
  </div>
  <div class="kb-aviso kb-aviso-peligro" *ngIf="!cargando && !sol && !noExiste && error">
    <i class="fas fa-exclamation-circle mt-0.5" aria-hidden="true"></i>
    <div>
      <p>{{ error }}</p>
      <button type="button" class="kb-btn kb-btn-outline kb-btn-sm mt-3" (click)="cargar()">
        <i class="fas fa-redo" aria-hidden="true"></i>Volver a consultar
      </button>
    </div>
  </div>

  <ng-container *ngIf="!cargando && sol">

    <!-- No la tienes tú, o tu perfil no llena nada acá -->
    <div class="kb-aviso kb-aviso-info" *ngIf="!puedeCargar">
      <i class="fas fa-info-circle mt-0.5" aria-hidden="true"></i>
      <div>
        <p>Esta solicitud no la tienes tú, o tu perfil no llena ninguna sección acá.</p>
        <a class="kb-btn kb-btn-outline kb-btn-sm mt-3 !text-foreground" [routerLink]="['/console/altas', id]">Volver a la solicitud</a>
      </div>
    </div>

    <ng-container *ngIf="puedeCargar">

      <div class="kb-page-header">
        <div>
          <h1 class="kb-page-title">{{ tituloParte }}</h1>
          <p class="kb-page-meta">{{ sol.numero }} · {{ sol.datos.nombre_comercial || sol.numero }}<ng-container *ngIf="!cargaCondiciones"> · Paso {{ indexActual + 1 }} de {{ pasosDef.length }}</ng-container></p>
        </div>
      </div>

      <app-riel-pasos *ngIf="!cargaCondiciones || !enRielDeCondiciones" [pasos]="pasosRiel" [navegable]="true" rotulo="Pasos de tu parte" (elegir)="irAPaso($event)"></app-riel-pasos>

      <div class="kb-aviso kb-aviso-peligro mt-4" *ngIf="errorPaso" role="alert">
        <i class="fas fa-exclamation-circle mt-0.5" aria-hidden="true"></i>
        <p>{{ errorPaso }}</p>
      </div>

      <!-- ══ Paso: Datos del comercio ══════════════════════════════════════════════════════════ -->
      <div class="kb-card mt-4" *ngIf="pasoActual === 'datos'">
        <div class="kb-card-header">
          <div>
            <p class="kb-seccion-rotulo">Datos del comercio</p>
            <p class="kb-card-desc">Lo que identifica al comercio ante CrediTotal.</p>
          </div>
        </div>
        <div class="kb-card-body">
          <div class="grid gap-4 sm:grid-cols-2">
            <div>
              <label class="kb-label" for="acNombreCom">Nombre comercial</label>
              <input id="acNombreCom" type="text" class="kb-input" [(ngModel)]="formDatos.nombre_comercial">
            </div>
            <div>
              <label class="kb-label" for="acRazon">Razón social</label>
              <input id="acRazon" type="text" class="kb-input" [(ngModel)]="formDatos.razon_social">
            </div>
            <div>
              <label class="kb-label" for="acRif">RIF</label>
              <app-rif-input inputId="acRif" [(valor)]="formDatos.rif"></app-rif-input>
            </div>
            <div *ngFor="let p of PIEZAS_FISCAL">
              <label class="kb-label" [for]="'acFiscal_' + p.clave">{{ p.rotulo }} <span class="kb-texto-peligro" *ngIf="p.obligatorio">*</span></label>
              <input [id]="'acFiscal_' + p.clave" type="text" class="kb-input" [(ngModel)]="formFiscal[p.clave]">
            </div>
            <div>
              <label class="kb-label" for="acTipoPersona">Tipo de persona</label>
              <div class="kb-select-envoltorio">
                <select id="acTipoPersona" class="kb-select" [(ngModel)]="formDatos.tipo_persona">
                  <option value="">Sin especificar</option>
                  <option value="JURIDICA">Jurídica</option>
                  <option value="NATURAL">Natural</option>
                </select>
                <i class="fas fa-chevron-down kb-select-flecha" aria-hidden="true"></i>
              </div>
            </div>
            <div>
              <label class="kb-label" for="acTelefono">Teléfono</label>
              <input id="acTelefono" type="tel" class="kb-input" placeholder="0412-5550101" [(ngModel)]="formDatos.telefono"
                     [ngClass]="{'kb-input-invalido': telefonoInvalido(formDatos.telefono)}">
              <p class="kb-hint kb-texto-peligro" *ngIf="telefonoInvalido(formDatos.telefono)">{{ AYUDA_TELEFONO }}</p>
            </div>
            <div>
              <label class="kb-label" for="acCorreoDatos">Correo</label>
              <input id="acCorreoDatos" type="email" class="kb-input" [(ngModel)]="formDatos.correo">
            </div>
            <div class="sm:col-span-2">
              <label class="kb-label" for="acDescr">Descripción</label>
              <textarea id="acDescr" rows="2" class="kb-textarea" [(ngModel)]="formDatos.descripcion"></textarea>
            </div>
            <div class="sm:col-span-2">
              <p class="kb-label" id="acCentrosRotulo">Centros de beneficio</p>
              <!-- Adrián, o24 del 13-oct: un select de varios, y el administrador de altas agrega centros desde ahí. -->
              <app-centros-select inputId="acCentros" rotuloId="acCentrosRotulo" [centros]="centros" [esAdmin]="!!sol?.es_admin"
                                  [(seleccion)]="formCentros" (creado)="alCrearCentro($event)"></app-centros-select>
              <p class="kb-hint">A cuáles pertenece el comercio. Puede ser más de uno; hace falta al menos uno para aprobar.</p>
            </div>
          </div>
        </div>
      </div>

      <!-- ══ Paso: Canales de venta (antes de los contactos: de ellos sale si el técnico es obligatorio) ═══ -->
      <div class="kb-card mt-4" *ngIf="pasoActual === 'canales'">
        <div class="kb-card-header">
          <div>
            <p class="kb-seccion-rotulo">Canales de venta</p>
            <p class="kb-card-desc">Por dónde va a vender el comercio. No es parte del contrato: después se cambian desde la ficha del comercio.</p>
          </div>
        </div>
        <div class="kb-card-body">
          <app-canales-venta [(canales)]="formCanales"></app-canales-venta>
        </div>
      </div>

      <!-- ══ Paso: Contactos ═══════════════════════════════════════════════════════════════════ -->
      <div class="kb-card mt-4" *ngIf="pasoActual === 'contactos'">
        <div class="kb-card-header">
          <div>
            <p class="kb-seccion-rotulo">Contactos</p>
            <p class="kb-card-desc">A quién se llama por cada cosa. Un contacto puede tener varios papeles.</p>
          </div>
        </div>
        <div class="kb-card-body">
          <p class="text-sm kb-texto-alerta" *ngIf="faltanContactos">
            <i class="fas fa-exclamation-triangle" aria-hidden="true"></i> {{ faltanContactos }}
          </p>
          <p class="kb-hint kb-texto-alerta" *ngIf="tecnicoObligatorio">
            <b>{{ tecnicoObligatorio }}.</b> Agrega el contacto técnico o márcale el papel Técnico a uno que ya esté: a él le llegan las claves.
          </p>
          <p class="kb-hint" *ngIf="!tecnicoObligatorio">
            El papel Técnico es opcional: solo se pide si el comercio vende por Integración por API o Tienda en línea (se marca en «Canales de venta»).
          </p>

          <div class="ac-contacto-fila" *ngFor="let c of formContactos; let i = index">
            <div class="flex flex-wrap items-center justify-between gap-2">
              <div class="flex flex-wrap gap-1.5" role="group" [attr.aria-label]="'Papeles del contacto ' + (i + 1)">
                <button type="button" class="kb-badge cursor-pointer" *ngFor="let p of PAPELES"
                        [ngClass]="tienePapel(c, p.codigo) ? 'kb-badge-marca' : 'kb-badge-contorno'"
                        [attr.aria-pressed]="tienePapel(c, p.codigo)"
                        (click)="togglePapel(c, p.codigo)">
                  <i class="fas fa-check" *ngIf="tienePapel(c, p.codigo)" aria-hidden="true"></i>{{ p.nombre }}
                </button>
              </div>
              <button type="button" class="kb-btn kb-btn-ghost kb-btn-icon" (click)="quitarContacto(i)"
                      [disabled]="formContactos.length <= 1" [attr.aria-label]="'Quitar el contacto ' + (c.nombre || (i + 1))">
                <i class="fas fa-times" aria-hidden="true"></i>
              </button>
            </div>
            <div class="ac-contacto-campos">
              <div>
                <label class="kb-label" [for]="'acNombreC' + i">Nombre</label>
                <input [id]="'acNombreC' + i" type="text" class="kb-input" [(ngModel)]="c.nombre">
              </div>
              <div>
                <label class="kb-label" [for]="'acCorreo' + i">Correo</label>
                <input [id]="'acCorreo' + i" type="email" class="kb-input" [(ngModel)]="c.correo">
              </div>
              <div>
                <label class="kb-label" [for]="'acTel' + i">Teléfono</label>
                <input [id]="'acTel' + i" type="tel" class="kb-input" placeholder="0412-5550101" [(ngModel)]="c.telefono"
                       [ngClass]="{'kb-input-invalido': telefonoInvalido(c.telefono)}">
                <p class="kb-hint kb-texto-peligro" *ngIf="telefonoInvalido(c.telefono)">{{ AYUDA_TELEFONO }}</p>
              </div>
            </div>
          </div>

          <button type="button" class="kb-btn kb-btn-outline kb-btn-sm mt-2" (click)="agregarContacto()">
            <i class="fas fa-plus" aria-hidden="true"></i>Agregar contacto
          </button>
          <p class="kb-hint mt-2" *ngIf="!contactosValidos">Falta el contacto administrador, o algún nombre.</p>
        </div>
      </div>

      <!-- ══ Paso: Cuenta bancaria ═════════════════════════════════════════════════════════════ -->
      <div class="kb-card mt-4" *ngIf="pasoActual === 'cuenta'">
        <div class="kb-card-header">
          <div>
            <p class="kb-seccion-rotulo">Cuenta bancaria</p>
            <p class="kb-card-desc">Dónde se le liquida al comercio. Queda como su cuenta principal.</p>
          </div>
        </div>
        <div class="kb-card-body">
          <app-cuenta-bancaria-form [valor]="cuentaActual" [razonSocial]="sol.datos.razon_social || ''"
              [rif]="sol.datos.rif || ''" (cambio)="cuentaActual = $event">
          </app-cuenta-bancaria-form>
          <p class="kb-hint mt-3" *ngIf="guardandoCuenta"><i class="fas fa-spinner fa-spin" aria-hidden="true"></i> Guardando…</p>
        </div>
      </div>

      <!-- ══ Paso: Tienda y caja (Juan, 2026-10-08) ═════════════════════════════════════════════ -->
      <div class="kb-card mt-4" *ngIf="pasoActual === 'tienda'">
        <div class="kb-card-header">
          <div>
            <p class="kb-seccion-rotulo">Tienda y caja</p>
            <p class="kb-card-desc">La primera tienda del comercio y su caja. Al aprobar el alta se crean con estos datos.</p>
          </div>
        </div>
        <div class="kb-card-body">
          <div class="grid gap-4 sm:grid-cols-2">
            <div>
              <label class="kb-label" for="acTiendaCodigo">Código de la tienda <span class="text-destructive">*</span></label>
              <input id="acTiendaCodigo" type="text" class="kb-input uppercase" maxlength="20" [(ngModel)]="formTienda.codigo" placeholder="Ej.: DA-01">
              <p class="kb-hint mt-1">Letras, números, guion, punto o guion bajo; sin espacios. Te proponemos uno; puedes cambiarlo. No se puede repetir.</p>
              <p class="kb-hint mt-1" *ngIf="codigoTiendaAlNacer">Al aprobar queda <span class="font-mono">{{ codigoTiendaAlNacer }}</span>: lleva el código completo del comercio, que se conoce al crearlo. Si escribes otro código, queda tal cual.</p>
            </div>
            <div>
              <label class="kb-label" for="acTiendaNombre">Nombre de la tienda <span class="text-destructive">*</span></label>
              <input id="acTiendaNombre" type="text" class="kb-input" maxlength="80" [(ngModel)]="formTienda.nombre">
              <p class="kb-hint mt-1">Como la conoce el comercio: sale en el portal y en cada venta.</p>
            </div>
            <div>
              <label class="kb-label" for="acTiendaNombreCorto">Nombre corto <span class="text-destructive">*</span></label>
              <input id="acTiendaNombreCorto" type="text" class="kb-input" maxlength="30" [(ngModel)]="formTienda.nombre_corto">
              <p class="kb-hint mt-1">Así sale en ventas y en el archivo para Odoo. Hasta 30 caracteres.</p>
            </div>
            <div>
              <label class="kb-label" for="acTiendaDireccion">Dirección</label>
              <input id="acTiendaDireccion" type="text" class="kb-input" [(ngModel)]="formTienda.direccion">
            </div>
            <div>
              <label class="kb-label" for="acTiendaCiudad">Ciudad</label>
              <input id="acTiendaCiudad" type="text" class="kb-input" [(ngModel)]="formTienda.ciudad">
            </div>
            <div>
              <label class="kb-label" for="acCaja">Número de la caja <span class="text-destructive">*</span></label>
              <input id="acCaja" type="number" min="1" max="9999" step="1" class="kb-input" aria-describedby="acCajaMsg" [(ngModel)]="formTienda.caja">
              <p class="kb-hint kb-texto-peligro mt-1" id="acCajaMsg" role="status" *ngIf="$any(formTienda.caja) !== null && $any(formTienda.caja) !== '' && cajaMala(formTienda.caja)">{{ MSG_CAJA }}</p>
              <p class="kb-hint mt-1">La caja con la que la tienda empieza a vender. Es la que viaja en cada venta.</p>
            </div>
          </div>

          <!-- Juan, 2026-10-19: el usuario de la caja y el gerente de la tienda; nacen con el comercio. La caja no es una persona: no se pide cajero -->
          <div class="kb-seccion mt-6">
            <div class="kb-seccion-regla">
              <span class="kb-seccion-rotulo">Usuario de la caja</span>
              <span class="kb-seccion-linea" aria-hidden="true"></span>
            </div>
            <div class="grid gap-4 sm:grid-cols-3 mt-3">
              <div>
                <label class="kb-label" for="acCajaUsuario">Usuario de la caja en el portal</label>
                <input id="acCajaUsuario" type="text" class="kb-input font-mono" [value]="usuarioCajaPropuesto" readonly aria-readonly="true">
                <p class="kb-hint mt-1">Lo propone el sistema: código del comercio y número de caja. Es el usuario de la caja, no de una persona; su clave le llega al gerente.</p>
              </div>
            </div>

            <div class="kb-seccion-regla mt-6">
              <span class="kb-seccion-rotulo">Gerente de la tienda</span>
              <span class="kb-seccion-linea" aria-hidden="true"></span>
            </div>
            <div class="grid gap-4 sm:grid-cols-3 mt-3">
              <div>
                <label class="kb-label" for="acGerenteNombre">Nombre del gerente <span class="text-destructive">*</span></label>
                <input id="acGerenteNombre" type="text" class="kb-input" maxlength="80" autocomplete="off" [(ngModel)]="formTienda.gerente.nombre">
              </div>
              <div>
                <label class="kb-label" for="acGerenteCorreo">Correo del gerente <span class="text-destructive">*</span></label>
                <input id="acGerenteCorreo" type="email" class="kb-input" autocomplete="off" aria-describedby="acGerenteCorreoMsg" [(ngModel)]="formTienda.gerente.correo">
                <p class="kb-hint kb-texto-peligro" id="acGerenteCorreoMsg" role="status" *ngIf="correoMalo(formTienda.gerente.correo)">Escriba un correo con &#64;, por ejemplo nombre&#64;dominio.com.</p>
              </div>
              <div>
                <label class="kb-label" for="acGerenteUsuario">Usuario en el portal</label>
                <input id="acGerenteUsuario" type="text" class="kb-input font-mono" [value]="usuarioGerentePropuesto" readonly aria-readonly="true">
                <p class="kb-hint mt-1">Lo propone el sistema: código del comercio y «gerente».</p>
              </div>
            </div>

            <div class="kb-seccion-regla mt-6">
              <span class="kb-seccion-rotulo">Vendedor</span>
              <span class="kb-seccion-linea" aria-hidden="true"></span>
            </div>
            <div class="grid gap-4 sm:grid-cols-3 mt-3">
              <div>
                <label class="kb-label" for="acVendedorNombre">Nombre del vendedor <span class="text-destructive" *ngIf="vendedorObligatorio">*</span></label>
                <input id="acVendedorNombre" type="text" class="kb-input" maxlength="80" autocomplete="off" [(ngModel)]="formTienda.vendedor.nombre">
              </div>
              <div>
                <label class="kb-label" for="acVendedorCorreo">Correo del vendedor <span class="text-destructive" *ngIf="vendedorObligatorio">*</span></label>
                <input id="acVendedorCorreo" type="email" class="kb-input" autocomplete="off" aria-describedby="acVendedorCorreoMsg" [(ngModel)]="formTienda.vendedor.correo">
                <p class="kb-hint kb-texto-peligro" id="acVendedorCorreoMsg" role="status" *ngIf="correoMalo(formTienda.vendedor.correo)">Escriba un correo con &#64;, por ejemplo nombre&#64;dominio.com.</p>
              </div>
              <div>
                <label class="kb-label" for="acVendedorUsuario">Usuario en el portal</label>
                <input id="acVendedorUsuario" type="text" class="kb-input font-mono" [value]="usuarioVendedorPropuesto" readonly aria-readonly="true">
                <p class="kb-hint mt-1">Lo propone el sistema: código del comercio y «vendedor».</p>
              </div>
            </div>
            <p class="kb-hint mt-2" [class.kb-texto-alerta]="vendedorObligatorio">
              <ng-container *ngIf="vendedorObligatorio"><b>Obligatorio: el comercio vende por Link de pago.</b> </ng-container>
              <ng-container *ngIf="!vendedorObligatorio">Solo se pide si el comercio vende por Link de pago. </ng-container>
              El vendedor manda la compra al teléfono del cliente.</p>

            <div class="kb-aviso kb-aviso-info mt-4">
              <i class="fas fa-info-circle mt-0.5" aria-hidden="true"></i>
              <div>
                <p class="kb-aviso-titulo">Las claves van en el PDF de credenciales</p>
                <p class="m-0">Al aprobarse el alta se generan las claves del gerente, de la caja<ng-container *ngIf="vendedorObligatorio"> y del vendedor</ng-container>, y salen en el PDF de credenciales de la solicitud. A cada uno le llegan por correo su usuario y la dirección del portal. La clave se cambia al entrar por primera vez. El administrador del portal<ng-container *ngIf="usuarioPortalPropuesto"> (<span class="font-mono">{{ usuarioPortalPropuesto }}</span>)</ng-container> se crea igual que hoy.</p>
              </div>
            </div>
          </div>
          <p class="kb-hint mt-3" *ngIf="guardandoTienda"><i class="fas fa-spinner fa-spin" aria-hidden="true"></i> Guardando…</p>
        </div>
      </div>

      <!-- ══ Paso: Documentos ══════════════════════════════════════════════════════════════════ -->
      <div class="kb-card mt-4" *ngIf="pasoActual === 'documentos'">
        <div class="kb-card-header">
          <div>
            <p class="kb-seccion-rotulo">Documentos</p>
            <p class="kb-card-desc">El RIF cuenta para crear; el resto, para aprobar sin necesitar una nota.</p>
          </div>
        </div>
        <div class="kb-card-body" *ngIf="!documentosEjecutivo.length">
          <p class="text-sm text-muted-foreground">Este tipo de solicitud no tiene documentos configurados.</p>
        </div>
        <div class="kb-card-body" *ngIf="documentosEjecutivo.length">
          <div class="ac-doc" *ngFor="let d of documentosEjecutivo">
            <div class="ac-doc-info">
              <p class="ac-doc-nombre">
                {{ d.nombre }}
                <span class="kb-badge kb-badge-contorno" *ngIf="!d.obligatorio">{{ d.para === 'CREAR' ? 'Para crear' : 'Para aprobar' }}</span>
                <!-- Adrián, #1194: el poder del apoderado no se suple con la nota; sin él no se aprueba. -->
                <span class="kb-badge kb-badge-marca" *ngIf="d.obligatorio">Obligatorio para aprobar</span>
              </p>
              <p class="kb-hint m-0" *ngIf="d.codigo === 'PODER'">Se pide porque el representante legal firma como apoderado.</p>
              <p class="ac-doc-estado" *ngIf="d.cargado">
                <span class="kb-texto-exito"><i class="fas fa-check-circle" aria-hidden="true"></i> {{ d.cargado.nombre_archivo }}</span>
              </p>
              <p class="ac-doc-estado kb-texto-alerta" *ngIf="!d.cargado">Falta</p>
            </div>
            <div class="ac-doc-acciones">
              <span class="kb-hint m-0" *ngIf="enColaTipo(d.codigo) && subiendoTipo !== d.codigo"><i class="fas fa-clock" aria-hidden="true"></i> En cola…</span>
              <span class="kb-hint m-0" *ngIf="subiendoTipo === d.codigo || quitandoTipo === d.codigo">
                <i class="fas fa-spinner fa-spin" aria-hidden="true"></i> {{ subiendoTipo === d.codigo ? 'Subiendo…' : 'Quitando…' }}
              </span>
              <a class="kb-btn kb-btn-ghost kb-btn-sm !text-foreground" *ngIf="d.cargado && !(puedeSubirDocumentos)"
                 [href]="urlDocumento(d.cargado.url)" target="_blank" rel="noopener">Ver</a>
              <ng-container *ngIf="d.cargado && (puedeSubirDocumentos)">
                <input #archivoDoc type="file" class="sr-only" accept="application/pdf,image/jpeg,image/png" tabindex="-1"
                       (change)="elegirArchivoDocumento(d, $event)">
                <app-kb-menu [chico]="true" etiqueta="Acciones del documento" [opciones]="opcionesDocumento"
                             [deshabilitado]="!!subiendoTipo || !!quitandoTipo" (elegir)="menuDocumento(d, $event, archivoDoc)"></app-kb-menu>
              </ng-container>
              <label class="kb-btn kb-btn-outline kb-btn-sm cursor-pointer m-0" *ngIf="!d.cargado && (puedeSubirDocumentos)">
                <i class="fas fa-file-upload" aria-hidden="true"></i>Subir
                <input type="file" class="sr-only" accept="application/pdf,image/jpeg,image/png"
                       (change)="elegirArchivoDocumento(d, $event)">
              </label>
            </div>
          </div>
        </div>
      </div>

      <!-- ══ Paso: La visita ═══════════════════════════════════════════════════════════════════ -->
      <div class="kb-card mt-4" *ngIf="pasoActual === 'visita'">
        <div class="kb-card-header">
          <div>
            <p class="kb-seccion-rotulo">La visita</p>
            <p class="kb-card-desc">Lo que viste al visitar el comercio.</p>
          </div>
        </div>
        <div class="kb-card-body">
          <p class="text-sm kb-texto-exito mb-3" *ngIf="hayComentarioVisita">
            <i class="fas fa-check-circle" aria-hidden="true"></i> Ya hay un comentario de la visita: puedes continuar sin escribir otro.
          </p>
          <label class="kb-label" for="acComentVisita">Comentario de la visita</label>
          <textarea id="acComentVisita" rows="3" class="kb-textarea" [(ngModel)]="comentarioVisita"
                    placeholder="Por ejemplo: el local está montado, atiende el dueño."></textarea>
        </div>
      </div>

      <!-- ══ Condiciones (gerente) — Juan, 2026-10-08: UN solo riel, el de las condiciones, con el
           contrato firmado como uno de sus pasos. Al guardar, de vuelta a la solicitud. ══════════════ -->
      <div class="kb-card mt-4" *ngIf="pasoActual === 'condiciones' || pasoActual === 'contrato'">
        <div class="kb-card-body">
          <app-condiciones-pasos modo="propuesta" [semilla]="sol.condiciones" [pasoInicial]="pasoCondiciones"
              [canales]="sol.canales" [contratoCargado]="!!documentoContrato?.cargado" [tienda]="sol.datos.tienda" [codigoComercio]="sol.codigo_previsto"
              [guardando]="guardandoCondiciones" [error]="errorCondiciones"
              (guardado)="guardarCondicionesEmbebidas($event)" (cancelado)="cancelarCondicionesEmbebidas()">
            <div paso-contrato *ngIf="documentoContrato as doc">
          <div class="ac-doc">
            <div class="ac-doc-info">
              <p class="ac-doc-nombre">
                {{ doc.nombre }}
                <span class="kb-badge kb-badge-contorno">{{ doc.para === 'CREAR' ? 'Para crear' : 'Para aprobar' }}</span>
              </p>
              <p class="ac-doc-estado" *ngIf="doc.cargado">
                <span class="kb-texto-exito"><i class="fas fa-check-circle" aria-hidden="true"></i> {{ doc.cargado.nombre_archivo }}</span>
              </p>
              <p class="ac-doc-estado kb-texto-alerta" *ngIf="!doc.cargado">Falta</p>
            </div>
            <div class="ac-doc-acciones">
              <span class="kb-hint m-0" *ngIf="enColaTipo(doc.codigo) && subiendoTipo !== doc.codigo"><i class="fas fa-clock" aria-hidden="true"></i> En cola…</span>
              <span class="kb-hint m-0" *ngIf="subiendoTipo === doc.codigo || quitandoTipo === doc.codigo">
                <i class="fas fa-spinner fa-spin" aria-hidden="true"></i> {{ subiendoTipo === doc.codigo ? 'Subiendo…' : 'Quitando…' }}
              </span>
              <a class="kb-btn kb-btn-ghost kb-btn-sm !text-foreground" *ngIf="doc.cargado && !(true)"
                 [href]="urlDocumento(doc.cargado.url)" target="_blank" rel="noopener">Ver</a>
              <ng-container *ngIf="doc.cargado && (true)">
                <input #archivoContrato type="file" class="sr-only" accept="application/pdf,image/jpeg,image/png" tabindex="-1"
                       (change)="elegirArchivoDocumento(doc, $event)">
                <app-kb-menu [chico]="true" etiqueta="Acciones del documento" [opciones]="opcionesDocumento"
                             [deshabilitado]="!!subiendoTipo || !!quitandoTipo" (elegir)="menuDocumento(doc, $event, archivoContrato)"></app-kb-menu>
              </ng-container>
              <label class="kb-btn kb-btn-outline kb-btn-sm cursor-pointer m-0" *ngIf="!doc.cargado && (true)">
                <i class="fas fa-file-upload" aria-hidden="true"></i>Subir
                <input type="file" class="sr-only" accept="application/pdf,image/jpeg,image/png"
                       (change)="elegirArchivoDocumento(doc, $event)">
              </label>
            </div>
          </div>
            </div>
          </app-condiciones-pasos>
        </div>
      </div>


      <!-- ══ Navegación ════════════════════════════════════════════════════════════════════════
           El riel de condiciones trae sus propios botones; los pasos del gerente ANTES de él (canales y
           contactos) usan éstos: sin ellos no tenía cómo guardar ni seguir (ALTA-37). -->
      <div class="flex justify-between items-center mt-4" *ngIf="!cargaCondiciones || !enRielDeCondiciones">
        <a class="kb-btn kb-btn-ghost kb-btn-sm !text-foreground" [routerLink]="['/console/altas', id]">Volver a la solicitud</a>
        <div class="flex gap-2">
          <button type="button" class="kb-btn kb-btn-outline kb-btn-sm" *ngIf="!esPrimerPaso" [disabled]="navegando" (click)="anterior()">
            Anterior
          </button>
          <button type="button" class="kb-btn kb-btn-primary kb-btn-sm" *ngIf="mostrarBotonSiguiente" [disabled]="navegando" (click)="siguienteOFinal()">
            <i class="fas fa-spinner fa-spin" *ngIf="navegando" aria-hidden="true"></i>{{ textoBotonSiguiente }}
          </button>
        </div>
      </div>

    </ng-container>
  </ng-container>
</div>
